export default __webpack_public_path__ + "images/student/avatars/Blu-64096ef07188c5231d57873bff7a9e5a.png";